// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aI3j","name":"styles_name__1TQsE","phone":"styles_phone__1CrpE"};